/**
 * FP3-044 Phase A — Alerts strip mounted at the top of the Admin
 * Student Overview. Renders the server-computed `alerts[]` list
 * with severity-aware styling and `Action needed · N` count.
 *
 * Severity → swatch
 *   danger → red
 *   warn   → amber
 *   info   → slate
 */
import { Warning, Info } from "@phosphor-icons/react";
import { Card } from "@/components/ui/card";

const SEVERITY_STYLE = {
  danger: "bg-[#FBEEEE] border-[#F4D1D1] text-[#A8453A]",
  warn: "bg-[#FDF8F3] border-[#F2DDB9] text-[#9C6B2E]",
  info: "bg-[#F3F4F6] border-[#E5E7EB] text-[#4B5563]",
};

const ALERT_TO_TAB = {
  missing_dob: "profile",
  missing_sex: "profile",
  missing_eligibility: "profile",
  missing_lre: "profile",
  missing_iep_due_date: "profile",
  missing_met_due_date: "profile",
  iep_due_date_overdue: "profile",
  iep_due_date_due_soon: "profile",
  met_due_date_overdue: "profile",
  met_due_date_due_soon: "profile",
  unlinked_campus: "profile",
  no_team: "team",
  no_primary_provider: "team",
  fidelity_behind: "services",
};

export default function AdminAlertsStrip({ alerts = [], onJumpTab }) {
  if (!alerts.length) return null;
  const counted = alerts.length;
  return (
    <Card
      data-testid="admin-alerts-strip"
      className="bg-white border-[#E5E3DB] p-4 mb-5"
    >
      <div className="flex items-center gap-2 mb-3">
        <Warning size={14} weight="duotone" className="text-[#9C6B2E]" />
        <p className="text-[12px] font-medium text-[#1F2937]">
          Action needed · <span data-testid="admin-alerts-count">{counted}</span>
        </p>
      </div>
      <div className="flex flex-col gap-1.5">
        {alerts.map((a) => {
          const sev = SEVERITY_STYLE[a.severity] || SEVERITY_STYLE.info;
          const targetTab = ALERT_TO_TAB[a.key];
          const inner = (
            <p className="text-[12px] flex-1 truncate">{a.label}</p>
          );
          return (
            <div
              key={a.key}
              data-testid={`admin-alert-${a.key}`}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-md border text-[12px] ${sev}`}
            >
              <Info size={12} className="shrink-0" />
              {inner}
              {targetTab && onJumpTab && (
                <button
                  type="button"
                  onClick={() => onJumpTab(targetTab)}
                  data-testid={`admin-alert-jump-${a.key}`}
                  className="text-[11px] underline hover:no-underline"
                >
                  Open
                </button>
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
}
